import React from "react";

const ToggleCameraIcon = () => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            height="60px"
            width="60px"
            fill="#fff"
            x="0px"
            y="0px"
            className="toggleCamera"
            viewBox="0 0 60 40"
            enableBackground="new 0 0 60 40"
            xmlSpace="preserve"
        >
            <g>
                <g>
                    <g>
                        <path
                            d="M16.4,27.8C10,26.1,5.9,23.4,5.9,20.2c0-2.8,3.3-5.3,8.6-7v-0.8C6.2,14.7,0.6,18.9,0.6,23.6c0,5.1,6.4,9.4,15.7,11.6v4.1
				                l7.2-7.2l-7.2-7.2v2.9H16.4z"
                        />
                        <path
                            d="M50.4,13.8v-4l-5.7,4.7l5.7,4.6v-3.4c2.3,1.4,3.7,2.7,3.7,4.5c0,4-6.7,7.4-16,8.7v7.3c12.3-1.6,21.2-6.6,21.2-12.6
				                C59.4,19.9,55.9,16.2,50.4,13.8z"
                        />
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M40.1,4.8h-4l-2.5-2.5H27l-3,2.5h-3.7c-1.2,0-2.2,1-2.2,2.2v13.1c0,1.2,1,2.2,2.2,2.2h19.8c1.2,0,2.2-1,2.2-2.2v-13
			                C42.4,5.8,41.4,4.8,40.1,4.8z"
                    />
                    <path
                        d="M40.1,23.4H20.3c-1.8,0-3.2-1.4-3.2-3.2V7.1c0-1.8,1.4-3.2,3.2-3.2h3.4l3-2.5H34l2.5,2.5h3.6c1.8,0,3.2,1.4,3.2,3.2v13.1
			                C43.3,21.9,41.9,23.4,40.1,23.4z M20.3,5.8c-0.7,0-1.3,0.6-1.3,1.3v13.1c0,0.7,0.6,1.3,1.3,1.3h19.8c0.7,0,1.3-0.6,1.3-1.3V7.1
			                c0-0.7-0.6-1.3-1.3-1.3h-4.4l-2.5-2.5h-5.8l-3,2.5C24.4,5.8,20.3,5.8,20.3,5.8z"
                    />
                </g>
                <g id="Ellipse_4">
                    <g>
                        <path
                            className="tCameraSt1"
                            d="M30.2,20.2c-4,0-7.3-3.2-7.3-7s3.3-7,7.3-7s7.3,3.2,7.3,7S34.2,20.2,30.2,20.2z M30.2,7.3
				                c-3.3,0-6.1,2.6-6.1,5.8s2.7,5.8,6.1,5.8s6.1-2.6,6.1-5.8S33.5,7.3,30.2,7.3z"
                        />
                    </g>
                    <g>
                        <path
                            className="tCameraSt1"
                            d="M30.2,19.3c-3.5,0-6.4-2.7-6.4-6.1s2.9-6.1,6.4-6.1s6.4,2.7,6.4,6.1S33.7,19.3,30.2,19.3z M30.2,8.3
				                c-2.9,0-5.2,2.2-5.2,4.9s2.3,4.9,5.2,4.9s5.2-2.2,5.2-4.9S33,8.3,30.2,8.3z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default ToggleCameraIcon;
